(function () {
  const nav     = document.getElementById('wp-nav');
  const drawer  = document.getElementById('wp-nav-drawer');
  const burger  = nav?.querySelector('.wp-nav__hamburger');

  if (!nav) return;

  // ── Set --header-height CSS var so hero negative margin stays accurate
  function setHeaderHeight() {
    const group = nav.closest('[id^="shopify-section-group"]') || nav;
    document.documentElement.style.setProperty('--header-height', group.offsetHeight + 'px');
  }

  // ── Transparent ↔ Solid based on scroll position
  // Only goes transparent on pages that have a hero section behind the nav
  const hasHero = !!document.querySelector('.wp-hero-section');

  function updateSolid() {
    if (hasHero) {
      nav.classList.toggle('wp-nav--solid', window.scrollY > 20);
    } else {
      nav.classList.add('wp-nav--solid');
    }
  }

  window.addEventListener('scroll', updateSolid, { passive: true });
  window.addEventListener('resize', setHeaderHeight, { passive: true });
  setHeaderHeight();
  updateSolid();

  // ── Mobile Drawer
  function openDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    burger?.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    setTimeout(() => drawer.querySelector('a, button')?.focus(), 320);
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    burger?.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    burger?.focus();
  }

  burger?.addEventListener('click', openDrawer);

  drawer?.querySelectorAll('[data-wp-close]').forEach(el => {
    el.addEventListener('click', closeDrawer);
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && drawer?.getAttribute('aria-hidden') === 'false') closeDrawer();
  });

  // ── Shopify theme editor hot-reload
  document.addEventListener('shopify:section:load', e => {
    if (e.target.querySelector('#wp-nav')) { setHeaderHeight(); updateSolid(); }
  });
})();
